/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { Action, Store } from 'fierry/flux';


const State = new Date();


const Actions =
{
  Refresh: new Action(),
};


const refreshTime = (state, { time }) =>
{
  return time;
};


export default new Store(State, Actions,
[
  [Actions.Refresh, refreshTime],
]);

